import { localeAlternatives } from 'shared-locales';
import type { Locales } from 'shared-types';

type Params = {
  appLanguage: Locales;
  courseLanguage: string; // lang code
  supportedLanguages: Locales[];
};

/**
 * Returns the default interface language for a given course language.
 * If the course language is supported, the course language is returned.
 * If the course language is not supported, the app language is returned.
 */
const getDefaultInterfaceLanguage = ({
  appLanguage,
  courseLanguage,
  supportedLanguages
}: Params): Locales => {
  if (supportedLanguages.includes(localeAlternatives[courseLanguage])) {
    return localeAlternatives[courseLanguage];
  }

  return appLanguage;
};

export default getDefaultInterfaceLanguage;
